import React from "react";
import { Link } from 'react-router-dom'


import hero1 from '../../images/slider/slide-1.jpg'

import shape1 from '../../images/slider/sd1.png'
import shape2 from '../../images/slider/sd2.png'

import bnImg from '../../images/main-banner.jpg'


const Hero3 =() => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="wpo-hero-section-3">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col col-xs-6 col-lg-6">
                        <div className="wpo-hero-section-text">
                            <div className="wpo-hero-title">
                                <h2>Dreamers Hub <span>Foundation</span></h2>
                            </div>
                            <div className="wpo-hero-subtitle">
                                <p>The Dreamer’s Hub Foundation (DHF) is a nonprofit organization focused on empowering individuals by providing practical financial education.</p>    
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="right-vec">
                            <div className="right-tiger-img">
                                <div className="r-img">
                                    <img src={bnImg} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sd-1"><img src={shape1} alt=""/></div>
            <div className="sd-2"><img src={shape2} alt=""/></div>
        </section>
    )
}



export default Hero3;
